<nz-modal
  nzWrapClassName="mb-modal-wrap"
  [(nzVisible)]="isVisible"
  [nzTitle]="titleTemplate"
  (nzOnCancel)="onCancel()"
  (nzOnOk)="onOk()"
  [nzCancelDisabled]="cancelDisabled"
  [nzWidth]="responsiveWidth"
  [nzCentered]="true"
  [nzZIndex]="1000"
  [nzBodyStyle]="{
    padding: '12px',
    borderRadius: '16px'
  }"
  [nzMaskStyle]="{
    backgroundColor: 'rgba(0, 0, 0, ' + maskOpacity + ')',
  }"
  [nzClosable]="false"
>
  <ng-template #titleTemplate>
    <div class="flex items-center justify-between gap-4 py-2 lg:p-6">
      <div class="flex items-center gap-2">
        @if (icon) {
          <img [src]="icon" alt="title icon" class="h-5 w-5" />
        }
        <span class="font-black">{{ title }}</span>
      </div>

      <button
        type="button"
        class="flex h-5 w-5 cursor-pointer items-center justify-center border-none bg-transparent p-0"
        (click)="onCancel()"
        [attr.aria-label]="'Close modal'"
      >
        <img
          [src]="ASSET_CONSTANTS.I_cancel"
          alt="Close modal"
          class="pointer-events-none h-5 w-5"
        />
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div cdkScrollable class="mb-modal-scroll-container">
      <ng-content></ng-content>
    </div>
  </ng-container>

  <div *nzModalFooter>
    <div class="flex w-full justify-end rounded-md p-4">
      <div class="flex gap-2">
        @if (alternativeActionButtonText) {
          <app-mb-button
            [label]="alternativeActionButtonText"
            (click)="alternativeActionHandler.emit()"
            type="ghost"
            [loading]="loading"
          />
        }
        <app-mb-button
          [label]="okText"
          (click)="onOk()"
          type="secondary"
          [disabled]="okDisabled"
          [loading]="loading"
        />
      </div>
    </div>
  </div>
</nz-modal>
